/**
 * Consumer Portal Layout
 *
 * Thin wrapper that renders child routes via Outlet.
 * All layout chrome (sidebar, header, breadcrumbs) is now handled by PageTemplate
 * which each page wraps itself in.
 *
 * @see PageTemplate.tsx — declarative page wrapper
 * @see PR #856 — Navigation & Layout Redesign
 */

import { Outlet } from 'react-router-dom';

export default function Layout() {
  return <Outlet />;
}
